/**
 * Bundler checkout discount popup (#bndlr-discount-message).
 * - Theme setting off: hide storewide (default).
 * - Theme setting on: allow popup; after shopper clicks "No", dismiss for the session.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tava_bundler_discount_dismissed';
  var BUNDLER_COOKIE = 'bndlr_hide_discount_message';
  var BUNDLER_COOKIE_VALUE = 'hide';
  var HTML_CLASS_DISMISSED = 'tava-bundler-popup-dismissed';
  var HTML_CLASS_DISABLED = 'tava-bundler-popup-disabled';
  var popupObserver = null;

  /** Reads Theme Settings → Bundler → Show Bundler discount popup from the script tag. */
  function isPopupEnabled() {
    var script =
      document.currentScript ||
      document.querySelector('script[src*="tava-bundler-popup"][data-popup-enabled]');
    if (!script) return false;
    return script.getAttribute('data-popup-enabled') === 'true';
  }

  /** Injects CSS so dismissed popups stay hidden before late Bundler paints. */
  function ensureDismissStyles() {
    if (document.getElementById('tava-bundler-popup-styles')) return;

    var style = document.createElement('style');
    style.id = 'tava-bundler-popup-styles';
    style.textContent =
      'html.' +
      HTML_CLASS_DISMISSED +
      ' #bndlr-discount-message,' +
      'html.' +
      HTML_CLASS_DISABLED +
      ' #bndlr-discount-message{display:none!important;visibility:hidden!important;pointer-events:none!important;}';
    document.head.appendChild(style);
  }

  /** True when the shopper dismissed the Bundler popup this browser session. */
  function isDismissedForSession() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  /** Sets Bundler's native hide cookie so its script skips displayCartValue. */
  function setBundlerHideCookie() {
    if (window.bndlr && typeof window.bndlr.setCookie === 'function') {
      // exdays = 0 creates a session cookie in Bundler's helper.
      window.bndlr.setCookie(BUNDLER_COOKIE, BUNDLER_COOKIE_VALUE, 0);
      return;
    }

    document.cookie = BUNDLER_COOKIE + '=' + BUNDLER_COOKIE_VALUE + ';path=/';
  }

  /** Hides the popup node when Bundler injects or re-shows it. */
  function hideBundlerPopup() {
    var popup = document.getElementById('bndlr-discount-message');
    if (!popup) return;

    popup.style.setProperty('display', 'none', 'important');
    popup.style.setProperty('visibility', 'hidden', 'important');
    popup.style.setProperty('pointer-events', 'none', 'important');
  }

  /** Watches for Bundler re-injecting the popup after cart updates. */
  function startPopupGuard(shouldHide) {
    if (popupObserver) return;

    popupObserver = new MutationObserver(function () {
      if (!shouldHide()) return;
      hideBundlerPopup();
      setBundlerHideCookie();
    });

    popupObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  /** Permanently suppresses the popup while the theme toggle is off. */
  function disablePopupStorewide() {
    document.documentElement.classList.add(HTML_CLASS_DISABLED);
    setBundlerHideCookie();
    hideBundlerPopup();
    startPopupGuard(function () {
      return true;
    });

    // Bundler may load after us — keep reinforcing the hide cookie.
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      setBundlerHideCookie();
      hideBundlerPopup();
      if (attempts >= 20) clearInterval(timer);
    }, 250);
  }

  /** Applies session dismissal state after the shopper clicks "No". */
  function applySessionDismissal() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      /* ignore private mode / blocked storage */
    }

    setBundlerHideCookie();
    document.documentElement.classList.add(HTML_CLASS_DISMISSED);
    hideBundlerPopup();
    startPopupGuard(isDismissedForSession);
  }

  /** Boots storewide disable, or session-dismiss when the popup is enabled. */
  function init() {
    ensureDismissStyles();

    if (!isPopupEnabled()) {
      disablePopupStorewide();
      return;
    }

    if (isDismissedForSession()) {
      applySessionDismissal();
      return;
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('.bndlr-message-no')) return;
        applySessionDismissal();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
